export class PetTagDetailsModel {
    tag_id: number
    pet_no: number
    pet_name: string
    location_id: number
    sublocation_id: number
    suffix: string
    department: string
    done_by: string
    clinic_no: number
    tag_no: string
    location_code: string
    location_desc: string
    sublocation_code: string
    sublocation_desc: string

    constructor(
        tag_id: number,
        pet_no: number,
        pet_name: string,
        location_id: number,
        sublocation_id: number,
        suffix: string,
        department: string,
        done_by: string,
        clinic_no: number,
        tag_no: string,
        location_code: string,
        location_desc: string,
        sublocation_code: string,
        sublocation_desc: string
    ) {
        this.tag_id = tag_id
        this.pet_no = pet_no
        this.pet_name = pet_name
        this.location_id = location_id
        this.sublocation_id = sublocation_id
        this.suffix = suffix
        this.department = department
        this.done_by = done_by
        this.clinic_no = clinic_no
        this.tag_no = tag_no
        this.location_code = location_code
        this.location_desc = location_desc
        this.sublocation_code = sublocation_code
        this.sublocation_desc = sublocation_desc
    }
}
